const labelStyle = {padding: '2px 4px', position: 'relative', bottom: '1px', cursor: 'default'}

export {labelStyle}
